 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		"runtime": 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"desktopVendor":"desktopVendor","battleStation":"battleStation","editPanel":"editPanel","react-giphy-tv":"react-giphy-tv","channel":"channel","reactGiphyGrid":"reactGiphyGrid","channelSelector":"channelSelector","creationTools":"creationTools","dagger":"dagger","gifDetail":"gifDetail","gifMaker":"gifMaker","gifMakerFinalize":"gifMakerFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerVideoTrim":"gifMakerVideoTrim","giphyLovesVine":"giphyLovesVine","header":"header","homepage":"homepage","search":"search","searchBar":"searchBar","tweetGif":"tweetGif","userDashboardAnalytics":"userDashboardAnalytics","gifEmbed":"gifEmbed","mediaLanding":"mediaLanding","mobileVendor":"mobileVendor","mobile":"mobile","mobileAboutPage":"mobileAboutPage","mobileChangePasswordPage":"mobileChangePasswordPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobileChannelSearchPage":"mobileChannelSearchPage","mobileDashboard":"mobileDashboard","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileGifMaker":"mobileGifMaker","mobileGifVideoPage":"mobileGifVideoPage","mobileJoinPage":"mobileJoinPage","mobileLoginPage":"mobileLoginPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileSearchResultsPage":"mobileSearchResultsPage","mobileTeamPage":"mobileTeamPage"}[chunkId]||chunkId) + "." + {"desktopVendor":"5ce638be","battleStation":"401883c6","editPanel":"edfd7118","react-giphy-tv":"819627b3","channel":"66388ff9","reactGiphyGrid":"9157539f","channelSelector":"62c27808","creationTools":"e4a83651","dagger":"2cd97613","gifDetail":"9a2c6d97","gifMaker":"2cb2740e","gifMakerFinalize":"963561b2","gifMakerSlideshow":"c7c5721c","gifMakerVideoTrim":"57850efe","giphyLovesVine":"f0c26c75","header":"37794b3f","homepage":"c8b8e351","search":"3c12d5ea","searchBar":"e86b51e4","tweetGif":"8d076eea","userDashboardAnalytics":"f139615f","gifEmbed":"734c9d32","mediaLanding":"75b904e6","mobileVendor":"7131d78f","mobile":"2b9fd0df","mobileAboutPage":"55cb4a8e","mobileChangePasswordPage":"2e43f48a","mobileChannelBranchPage":"6054c932","showdown":"6ed4d01d","mobileChannelLeafPage":"e58ab035","mobileChannelListPage":"d6205e9b","mobileChannelPage":"42df50d1","mobileChannelSearchPage":"7671c6a4","mobileDashboard":"6f19def0","mobileExploreCategoryPage":"7723ca7d","mobileExploreResultsPage":"83fce2f8","mobileFavoritesPage":"6dd6d987","mobileGifMaker":"85754829","mobileGifVideoPage":"c86c0821","mobileJoinPage":"2a3ccbf5","mobileLoginPage":"f7c16ae5","mobileResetPasswordPage":"a6ea0129","mobileSearchResultsPage":"a509ca55","mobileTeamPage":"ead8e513"}[chunkId] + ".bundle.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap bc19472618ec0090188f